import React, { Fragment, Component } from 'react';
import AddToCalendarButton from './add_to_calendar_button';
import AddToGoogleCalendarButton from './add_to_google_calendar_button';
import CancelViewing from './cancel_viewing';
import I18n from '~/utils/translations';

export default class DisplayViewing extends Component {
  get classes() {
    const classes = ['viewings__viewing-booked', 'book-viewing-section'];

    if (this.props.confirm) {
      classes.push('book-viewing-section--confirm');
    }

    return classes.join(' ');
  }

  renderCalendarButton() {
    return (
      <Fragment>
        <AddToGoogleCalendarButton
          headline={this.props.headline}
          location={this.props.fullAddress}
          viewingStart={this.props.viewingStart}
          viewingEnd={this.props.viewingEnd}
        />
        <AddToCalendarButton
          headline={this.props.headline}
          location={this.props.fullAddress}
          viewingStart={this.props.viewingStart}
          viewingEnd={this.props.viewingEnd}
        />
      </Fragment>
    );
  }

  renderCancelAction() {
    return (
      this.props.allowViewingCancel && (
        <CancelViewing
          handleViewingCancelled={this.props.handleViewingCancelled}
          viewingCancelError={this.props.viewingCancelError}
          property={this.props.property}
        />
      )
    );
  }

  renderCta() {
    if (this.props.children) {
      return this.props.children;
    }

    // only need the message below if users can't cancel the viewing themselves :)
    if (this.props.allowViewingCancel) {
      return null;
    }

    return (
      <p className="viewings__contact-us">
        If you would like to reschedule or cancel your viewing, email us at{' '}
        <a href={`mailto:${I18n.t('brand.email')}`}>{I18n.t('brand.email')}</a>.
      </p>
    );
  }

  render() {
    return (
      <section id="viewing-booked" className={this.classes}>
        <div className="viewings__viewing-booked-inner book-viewing-section__inner">
          {this.props.title && <h3 className="viewings__step-title">{this.props.title}</h3>}
          <div className="viewings__viewing-details-container">
            <div className="viewings__viewing-details">
              <div className="viewings__viewing-details-left">
                <div className="viewings__viewing-details-left-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.14 24.14" className="icon-svg icon-calendar">
                    <title>property-interest-enquiry-type-date</title>
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="_1" data-name="1">
                        <path d="M22.54,1.34H19.61a.54.54,0,1,0,0,1.07h2.92a.54.54,0,0,1,.54.54v3h-22V3a.54.54,0,0,1,.54-.54H4.53a.54.54,0,1,0,0-1.07H1.61A1.61,1.61,0,0,0,0,3V22.54a1.61,1.61,0,0,0,1.61,1.61H22.54a1.61,1.61,0,0,0,1.61-1.61V3A1.61,1.61,0,0,0,22.54,1.34Zm0,21.73H1.61a.54.54,0,0,1-.54-.54V7h22V22.54A.54.54,0,0,1,22.54,23.07Z" />
                        <path d="M8.85,2.41h6.44a.54.54,0,0,0,0-1.07H8.85a.54.54,0,1,0,0,1.07Z" />
                        <path d="M6.71,4.29a.54.54,0,0,0,.54-.54V.54a.54.54,0,1,0-1.07,0V3.76A.54.54,0,0,0,6.71,4.29Z" />
                        <path d="M17.44,4.29A.54.54,0,0,0,18,3.76V.54a.54.54,0,1,0-1.07,0V3.76A.54.54,0,0,0,17.44,4.29Z" />
                        <path d="M20.39,13.15a.54.54,0,1,0,0-1.07H18.24V9.66a.54.54,0,0,0-1.07,0v2.41H14.49V9.66a.54.54,0,0,0-1.07,0v2.41H10.73V9.66a.54.54,0,1,0-1.07,0v2.41H7V9.66a.54.54,0,0,0-1.07,0v2.41H3.76a.54.54,0,1,0,0,1.07H5.9V16.9H3.76a.54.54,0,1,0,0,1.07H5.9v1.34a.54.54,0,0,0,1.07,0V18H9.66v1.34a.54.54,0,1,0,1.07,0V18h2.68v1.34a.54.54,0,1,0,1.07,0V18h2.68v1.34a.54.54,0,0,0,1.07,0V18h2.15a.54.54,0,0,0,0-1.07H18.24V13.15ZM7,16.9V13.15H9.66V16.9Zm3.76,0V13.15h2.68V16.9Zm6.44,0H14.49V13.15h2.68Z" />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="viewings__viewing-details-right">
                <h2 className="viewings__full-address">
                  {this.props.fullAddress}
                  <br />
                  <strong className="chosen-time">{this.props.datetime}</strong>
                </h2>
              </div>
            </div>
            {this.props.viewingStart && this.props.hasConfirmedViewing && this.renderCalendarButton()}
            {this.props.viewingStart && this.renderCancelAction()}
          </div>
          <div className="viewing-details-cta">{this.renderCta()}</div>
        </div>
      </section>
    );
  }
}
